import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType, ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

type Props = {
  size?: number | string
}

export const AuroraGuidedSelfCareSecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors, isAuroraTheme } = useTheme() as ThemeType
  // early return to prevent crash if theme transitions from aurora to non-aurora (currently happening upon android log out)
  if (!isAuroraTheme) return null
  const { spotIllustration } = colors.icons as AuroraThemeType['colors']['icons']

  return (
    <Svg
      width={size}
      height={size}
      viewBox='0 0 64 64'
      fill='none'
      testID={tID('AuroraGuidedSelfCareSecondaryRecIllustration')}
    >
      <Path d='M23.6262 14.8711L23.6246 14.8758L23.623 14.8711H23.6262Z' fill='#3BA5B5' />
      <Path d='M23.6266 14.8672L23.6297 14.8703H23.625L23.6266 14.8672Z' fill='#3BA5B5' />
      <Path
        d='M54.9523 44.4636C54.9445 45.1184 54.5143 45.6974 53.8761 45.911C51.6377 46.6603 46.3584 48.4529 42.8499 49.8369C38.7015 51.4731 34.561 52.6512 33.8603 52.8463C33.7867 52.8664 33.7132 52.8819 33.6366 52.8927C33.2189 52.9484 31.7736 53.1079 30.3345 52.8757C30.3345 52.8757 30.322 52.871 30.2969 52.8633C29.4507 52.5816 14.2449 47.507 9.96982 45.7314C9.38167 45.4868 9 44.9264 9 44.3057V13.8725C9 12.7826 10.1247 12.0349 11.1727 12.425C16.4395 14.3926 29.5117 19.8139 30.2954 20.1405C30.3188 20.1498 30.3329 20.1545 30.3329 20.1545H33.4661C33.6585 20.1545 33.8493 20.1204 34.0276 20.0554L52.7592 13.2192C53.8088 12.8368 54.9272 13.5923 54.9194 14.6806C54.8866 19.2009 54.8287 29.1456 54.9366 31.6534C55.0508 34.2836 54.982 41.6647 54.9507 44.4636H54.9523Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M52.2981 12.7397V43.4345L32.2135 50.6608C32.1149 50.6948 32.0101 50.7041 31.9084 50.6825C31.8865 50.6778 31.8646 50.6716 31.8427 50.6639L11.5156 43.662V12.3604C11.5156 11.9068 11.8332 11.5074 12.2805 11.4114C24.2907 8.81226 31.9084 19.3777 31.9084 19.3777C34.9821 13.1638 47.2629 11.8975 51.1281 11.6498C51.7632 11.6096 52.2981 12.1096 52.2981 12.7381V12.7397Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M52.2979 12.739V43.4338L32.2132 50.6601C32.1147 50.6942 32.0099 50.7035 31.9082 50.6818V19.3786C32.9046 17.363 34.8693 15.8676 37.2015 14.7607C39.16 13.8288 41.3749 13.1709 43.4944 12.708C46.637 12.016 49.5668 11.7513 51.1279 11.6507C51.7629 11.6105 52.2979 12.1105 52.2979 12.739Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M43.4941 12.707L43.1953 23.6765L40.3844 21.5944L37.2012 25.1859V14.7598C39.1596 13.8278 41.3745 13.1699 43.4941 12.707Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M32.4316 49.7626L32.4316 20.7132C32.4316 20.4228 32.1963 20.1875 31.906 20.1875C31.6157 20.1875 31.3803 20.4228 31.3803 20.7132L31.3803 49.7626C31.3803 50.053 31.6157 50.2883 31.906 50.2883C32.1963 50.2883 32.4316 50.053 32.4316 49.7626Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
